define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/config",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/locale",
	"csi/reflection",
	"csi/middleware/rollup/rollupService",
	"csi/xml",
	"csi/xml/Query"
], function (declare, lang, config, Action, ViewRef, locale, reflection, { validateValue }, xml, Query) {

	return declare(null, {
		/**
		 * @override
		 * Override default store key with subtype as key to improve caching of stores
		 */
		getCustomStoreKey: function (ctx, h, bAll) {
			const valueAttributeNode = this._getValueAttributeNode(ctx);

			if (!valueAttributeNode) {
				return this.inherited(arguments);
			} else {
				const viewRefParams = this._getViewRefParams(ctx);
				return valueAttributeNode.LookupItemSubtype + (viewRefParams ? ("^" + viewRefParams.m_url) : "");
			}
		},

		/**
		 * @override
		 * Validate the expression and throw error message specified on the ValueAttributeDefinition node
		 */
		validateValue: function (ctx, h, value) {
			const valueAttributeNode = this._getValueAttributeNode(ctx);
			if (!valueAttributeNode) {
				return;
			}

			var validationExpression = valueAttributeNode.ValidationExpression;
			if (validationExpression) {
				var validationResult = validateValue(value, validationExpression);
				if (validationResult === false) {
					throw new Error(valueAttributeNode.ValidationErrorMessage[locale.getLocale()]);
				}
			}
		},

		/**
		 * Get the ValueAttributeDefinition node if present on Actual's SpecificationItemDefinition
		 * @param {context} ctx
		 * @returns {object|null}
		 */
		_getValueAttributeNode: function (ctx) {
			const { cache } = ctx;
			const node = ctx.getNode();
			let ssi = null;
			let sid = null;
			if (!node) {
				return null;
			}

			// Use different paths depending on if node is SpecificationDataSheetItem or SpecificationDataSheetResponseItem
			if (node.$Type == "SpecificationDataSheetItem") {
				ssi = cache.get(node.Actual);
				sid = ssi && cache.get(ssi.Definition);
			} else {
				sid = cache.get(node.SpecDefinition);
			}

			const valueAttributeNode = sid && cache.get(sid.ValueAttributeDefinition);

			return valueAttributeNode;
		},

		/**
		 * Returns view ref params
		 * @param {context} ctx 
		 */
		_getViewRefParams: function (ctx) {
			const { cache } = ctx;
			const node = ctx.getNode();
			let ssi = null;

			if (!node) {
				return null;
			}

			// Use different paths depending on if node is SpecificationDataSheetItem or SpecificationDataSheetResponseItem
			if (node.$Type == "SpecificationDataSheetItem") {
				ssi = cache.get(node.Actual);
			}

			let viewRefParams = null;

			if (ssi && ssi.ApplicableValueLookupItems.length > 0) {
				viewRefParams = {
					m_id: "ApplicableValueLookupItems",
					m_url: ssi.$URL
				};
			} else if (node.ApplicableValueLookupItems && node.ApplicableValueLookupItems.length > 0) {
				viewRefParams = {
					m_id: "ApplicableValueLookupItems",
					m_url: node.$URL
				};
			} else {
				viewRefParams = {
					m_id: "LookupItems",
					m_url: "centric://REFLECTION/INSTANCE/_CS_Data/null"
				};
			}

			return viewRefParams;
		},

		/**
		 * @override
		 * Updated viewRef based on ApplicableValueLookupItems
		 */
		_getStoreAction: function (ctx, h, bAll) {
			const node = ctx.getNode();
			if (!node) {
				return null;
			}

			const valueAttributeNode = this._getValueAttributeNode(ctx);
			if (!valueAttributeNode) {
				return;
			}

			const subtypeUrl = valueAttributeNode.LookupItemSubtype;
			let viewRefParams = this._getViewRefParams(ctx);

			const fixedFiltersQuery = new Query().Attr("Active", xml.OP_EQUALS, true);

			fixedFiltersQuery.RefAttr("Subtype", xml.OP_EQUALS, subtypeUrl);

			viewRefParams.viewParams = {
				urlSubtype: subtypeUrl
			};

			return lang.mixin(new Action(), {
				m_fixedQuery: fixedFiltersQuery,
				m_viewRef: lang.mixin(new ViewRef(), viewRefParams)
			});
		}
	});
});
